import React from 'react';
import { Container, Row, Col, Form, CardBody, Card } from 'reactstrap';
import DimensionInput from '../../common/DimensionInput';

const DimensionComponent = () => {
    return (
        <React.Fragment>
            <div className='page-content components'>
                <Container>
                    <Card>
                        <CardBody>
                            <h2 className="mb-4">Dimension Input Showcase</h2>
                            <Form className="item-creation">
                                {/* First Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <DimensionInput
                                            label="Dimensions with Help"
                                            required={true}
                                            unitOptions={["cm", "m"]}
                                            defaultUnit="cm"
                                            helpText="Please enter the length, width, and height."
                                            showHelp={true}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<DimensionInput
    label="Dimensions with Help"
    required={true}
    unitOptions={["cm", "m"]}
    defaultUnit="cm"
    helpText="Please enter the length, width, and height."
    showHelp={true}
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Second Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <DimensionInput
                                            label="Inline Dimensions"
                                            required={true}
                                            layout="inline"
                                            unitOptions={["cm", "mm", "in"]}
                                            defaultUnit="cm"
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<DimensionInput
    label="Inline Dimensions"
    required={true}
    layout="inline"
    unitOptions={["cm", "mm", "in"]}
    defaultUnit="cm"
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Third Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <DimensionInput
                                            label="Optional Dimensions"
                                            required={false}
                                            placeholder="Enter dimensions (optional)"
                                            unitOptions={["cm", "m"]}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<DimensionInput
    label="Optional Dimensions"
    required={false}
    placeholder="Enter dimensions (optional)"
    unitOptions={["cm", "m"]}
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Fourth Row */}
                                <Row className="mb-4">
                                    <Col lg={6}>
                                        <DimensionInput
                                            label="Custom Validation Dimensions"
                                            required={true}
                                            minLength={1}
                                            maxLength={100}
                                            validationErrorMessage="Please enter valid dimensions."
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                            <pre>
                                                {`
<DimensionInput
    label="Custom Validation Dimensions"
    required={true}
    minLength={1}
    maxLength={100}
    validationErrorMessage="Please enter valid dimensions."
/>
                                                `}
                                            </pre>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DimensionComponent;
